if(!customElements.get('custom-contact-form')){

  class CustomContactForm extends HTMLElement {
    constructor(){
      super();

      this.init();
    }

    init(){
      this.inputWrappers = this.querySelectorAll('.input-wrapper');
      this.inputs = this.querySelectorAll('input, textarea');
      this.inputs.forEach(item => {
        item.addEventListener('focus', this.focusOnInput.bind(this));
        item.addEventListener('focusout', this.focusOutOnInput.bind(this));
        item.addEventListener('input', this.updateOnInput.bind(this));
        this.updateSelectedState(item);
      });

      this.labels = this.querySelectorAll('.input-wrapper label');
      this.labels.forEach(item => {
        item.addEventListener('click', (e) => {
          if(e.currentTarget.closest('.input-wrapper').getAttribute('data-selected') != 'true'){
            const inputs = e.currentTarget.closest('.input-wrapper').querySelectorAll('input, textarea');
            inputs.forEach(item => {
              item.focus();
            })
          }
        })
      })
    }

    // Wrappers without a text input (e.g. the reason select) keep their label raised permanently.
    resetEmptyWrappers(){
      this.inputWrappers.forEach(item => {
        var input = item.querySelector('textarea, input');
        if(input && input.value.trim() == '') item.setAttribute('data-selected', 'false');
      })
    }

    updateSelectedState(input){
      var inputWrapper = input.closest('.input-wrapper');
      if(inputWrapper && input.value.trim() != '') inputWrapper.setAttribute('data-selected', 'true');
    }

    focusOnInput(e){
      this.resetEmptyWrappers();

      var currentTargetInputWrapper = e.currentTarget.closest('.input-wrapper');
      if(currentTargetInputWrapper) currentTargetInputWrapper.setAttribute('data-selected', 'true');
    }

    focusOutOnInput(){
      this.resetEmptyWrappers();
    }

    // Covers browser autofill, which fills fields without focusing them.
    updateOnInput(e){
      this.updateSelectedState(e.currentTarget);
    }
  }

  customElements.define('custom-contact-form', CustomContactForm);

}
